import { ConnectWithUs } from "@/components/ConnectWithUs";
import { useMediaQuery } from "@react-hook/media-query";
import clsx from "classnames";
import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import image from "./image.png";
import styles from "./styles.module.scss";

export const Connecting = ({
  className,
  title,
  content,
  buttonText,
  buttonLink,
  backgroundColor,
}) => {
  const [visibleCount, setVisibleCount] = useState(1);
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  const md = useMediaQuery("only screen and (min-width: 768px)");

  useEffect(() => {
    setVisibleCount(lg ? 4 : md ? 2 : 1);
  }, [lg, md]);

  return (
    <div
      className={clsx(backgroundColor, styles.connecting)}
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="py-5">
        <Container fluid="lg">
          <Row>
            <Col xs={12} md={6}>
              {title && (
                <div
                  className="mb-4"
                  data-sourceflow-prop="title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
              {content && (
                <div
                  className="mb-5 mb-md-0"
                  data-sourceflow-prop="content"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
              {buttonText && (
                <Button
                  variant="blue"
                  href={buttonLink}
                  data-sourceflow-prop="buttonText"
                >
                  {buttonText}
                </Button>
              )}
            </Col>

            <Col xs={12} md={6}>
              <ConnectWithUs
                className={clsx(
                  styles.connecting__links,
                  "justify-content-start"
                )}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Connecting;
